import type { ElementType } from 'react';

import { Stack, Typography } from '@mui/material';

export interface BreadcrumbContentProps {
  label: string;
  icon?: ElementType;
}

const BreadcrumbContent = ({ label, icon: Icon }: BreadcrumbContentProps) => (
  <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
    {Icon ? <Icon sx={{ fontSize: 18 }} /> : null}
    <Typography component="span" variant="body2" sx={{ lineHeight: 1.2 }}>
      {label}
    </Typography>
  </Stack>
);

export default BreadcrumbContent;
